// Adressevaelger serves adgangspunkt coordinates in EPSG:25832 (ETRS89 /
// UTM 32N) and offers no WGS84 output mode.
//
// Ported from @coignite/danish-addresses-kds-js (MIT, Coignite ApS).
// Keep in sync with app/services/adressevaelger/utm32.rb.
//
// CommonJS on purpose: bin/check-address-js require()s it under plain Node, and
// adding async here would make Babel inject an ESM import, which turns
// module.exports read-only under webpack. Keep this file async-free.

const A = 6378137.0; // GRS80 semi-major axis
const F = 1 / 298.257222101; // GRS80 flattening
const K0 = 0.9996; // UTM scale factor
const FALSE_EASTING = 500000.0;
const LON_ORIGIN = (9 * Math.PI) / 180; // zone 32N central meridian

function utm32ToWgs84(easting, northing) {
    const e2 = F * (2 - F);
    const e1 = (1 - Math.sqrt(1 - e2)) / (1 + Math.sqrt(1 - e2));
    const ep2 = e2 / (1 - e2);

    const m = northing / K0;
    const mu = m / (A * (1 - e2 / 4 - (3 * e2 ** 2) / 64 - (5 * e2 ** 3) / 256));

    const phi1 =
        mu +
        ((3 * e1) / 2 - (27 * e1 ** 3) / 32) * Math.sin(2 * mu) +
        ((21 * e1 ** 2) / 16 - (55 * e1 ** 4) / 32) * Math.sin(4 * mu) +
        ((151 * e1 ** 3) / 96) * Math.sin(6 * mu) +
        ((1097 * e1 ** 4) / 512) * Math.sin(8 * mu);

    const c1 = ep2 * Math.cos(phi1) ** 2;
    const t1 = Math.tan(phi1) ** 2;
    const n1 = A / Math.sqrt(1 - e2 * Math.sin(phi1) ** 2);
    const r1 = (A * (1 - e2)) / (1 - e2 * Math.sin(phi1) ** 2) ** 1.5;
    const d = (easting - FALSE_EASTING) / (n1 * K0);

    const lat =
        phi1 -
        ((n1 * Math.tan(phi1)) / r1) *
            ((d ** 2) / 2 -
                ((5 + 3 * t1 + 10 * c1 - 4 * c1 ** 2 - 9 * ep2) * d ** 4) / 24 +
                ((61 + 90 * t1 + 298 * c1 + 45 * t1 ** 2 - 252 * ep2 - 3 * c1 ** 2) * d ** 6) / 720);

    const lon =
        LON_ORIGIN +
        (d -
            ((1 + 2 * t1 + c1) * d ** 3) / 6 +
            ((5 - 2 * c1 + 28 * t1 - 3 * c1 ** 2 + 8 * ep2 + 24 * t1 ** 2) * d ** 5) / 120) /
            Math.cos(phi1);

    return [(lon * 180) / Math.PI, (lat * 180) / Math.PI];
}

module.exports = { utm32ToWgs84 };
